// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__28IWI","header":"MessagesList_header__2nSkN","chat":"MessagesList_chat__1zGH2"};